/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type StatusWithDescription_projectStatus$ref: FragmentReference;
declare export opaque type StatusWithDescription_projectStatus$fragmentType: StatusWithDescription_projectStatus$ref;
export type StatusWithDescription_projectStatus = {|
  +id: string,
  +person: ?{|
    +id: string,
    +fullName: ?string,
    +profilePictureId: ?string,
    +profilePictureDefaultId: ?number,
  |},
  +description: ?string,
  +color: ?string,
  +day: ?number,
  +month: ?number,
  +year: ?number,
  +$refType: StatusWithDescription_projectStatus$ref,
|};
export type StatusWithDescription_projectStatus$data = StatusWithDescription_projectStatus;
export type StatusWithDescription_projectStatus$key = {
  +$data?: StatusWithDescription_projectStatus$data,
  +$fragmentRefs: StatusWithDescription_projectStatus$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StatusWithDescription_projectStatus",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "person",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profilePictureId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profilePictureDefaultId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "day",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "month",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "year",
      "storageKey": null
    }
  ],
  "type": "ProjectStatus"
};
})();
// prettier-ignore
(node/*: any*/).hash = '50e9065648a698fab579adfa21103907';

module.exports = node;
